import { Attributes, DateUtils, List, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class LadderProjection extends ModelBase {
    static typeName = "LadderProjection";

    public ladderProjectionId: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public description: string = "";

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public effectiveDate: Date = DateUtils.today();

    @Attributes.Float()
    public amount: number = 0;

    public ladderAgeId: number | null = null;

    public isBankOnly: boolean = false;

    public isAsset: boolean = false;

    public isDividend: boolean = false;

    public isActive: boolean = true;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<LadderProjection>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.description) {
            return "New ladder projection";
        } else {
            return this.description;
        }
    }
}